<template>
  <div id="user-card-container" :class="{ 'waiting': payment_in_progress, 'user-card-container': true }">
    <div class="mask"></div>
    <div class="pl-6 pr-6">
      <form action="" id="espago_form" method="POST" class="mt-4">
        <fieldset class="form-row">
          <div class="form-field form-required mb-4">
            <label class="label">Numer Karty</label>
            <input
              id="espago_card_number"
              class="form-control"
              type="text"
              value=""
            />
            <span class="form-error" id="espago_card_number_error"></span>
          </div>
          <div class="form-field form-required mb-4">
            <label class="label">Imię</label>
            <input
              class="required form-control"
              id="espago_first_name"
              type="text"
              value=""
            />
            <span class="form-error" id="espago_first_name_error"></span>
            <br />
          </div>

          <div class="form-field form-required mb-4">
            <label class="label">Nazwisko</label>
            <input
              class="required form-control"
              id="espago_last_name"
              type="text"
              value=""
            />
            <span class="form-error" id="espago_last_name_error"></span>
            <br />
          </div>

          <div class="form-field form-required mb-4">
            <label class="label">Miesiąc wygaśnięcia</label>
            <input
              class="required form-control digits"
              id="espago_month"
              type="text"
              placeholder="--"
              value=""
            />
            <span class="form-error" id="espago_month_error"></span>
            <br />
          </div>

          <div class="form-field form-required mb-4">
            <label class="label">Rok wygaśnięcia</label>
            <input
              class="required form-control digits"
              id="espago_year"
              type="text"
              placeholder="----"
              value=""
            />
            <span class="form-error" id="espago_year_error"></span>
            <br />
          </div>
          <div class="form-field form-required mb-4">
            <label class="label">Numer CVC</label>
            <input
              class="required form-control digits"
              id="espago_verification_value"
              type="text"
              value=""
              placeholder="---"
            />
            <span class="form-error" id="espago_verification_value_error"></span>
          </div>
        </fieldset>
        <input id="espagoCard" type="hidden" name="card_token" value="" />
        <p class="form-error">{{ response_message }}</p>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EspagoCardForm",
  props: {
    payment_in_progress: {
      type: Boolean,
      required: false,
    },
    response_message: {
      type: String,
      required: false,
    }
  }
};
</script>

<style scoped lang="scss">
.user-card-container {
  position: relative;
}

.user-card-container.waiting .mask::after {
  content: "";
  width: 30px;
  height: 30px;
  display: block;
  background: transparent
    url("https://magazynpismo.pl/wp-content/themes/pismo-wp-theme/images/icons/waiting.gif")
    center;
}

.user-card-container.done .mask,
.user-card-container.waiting .mask {
  align-items: center;
  justify-content: center;
  z-index: 1;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>